/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Ingest_Approval_Attachment_CountInputs */

const es_components_ingest_approval_attachment_count = /** @type {(inputs: Components_Ingest_Approval_Attachment_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} adjunto(s)`)
};

const en_components_ingest_approval_attachment_count = /** @type {(inputs: Components_Ingest_Approval_Attachment_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} attachment(s)`)
};

/**
* | output |
* | --- |
* | "{count} attachment(s)" |
*
* @param {Components_Ingest_Approval_Attachment_CountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ingest_approval_attachment_count = /** @type {((inputs: Components_Ingest_Approval_Attachment_CountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ingest_Approval_Attachment_CountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ingest_approval_attachment_count(inputs)
	return en_components_ingest_approval_attachment_count(inputs)
});
export { components_ingest_approval_attachment_count as "components.ingest_approval.attachment_count" }